module.exports = __webpack_public_path__ + "static/img/权限隔离@2x2.563e2947.png";